module.exports = __webpack_public_path__ + "static/img/img11.f4125c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img11.jpg
// module id = xjoE
// module chunks = 1